export default {
  addPage: {
    scan: "Scan page",
    upload: "Upload page",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out"
  },
  bucketType: {
    standalone: "Receipt",
    trip: "Trip"
  },
  cancel: "Cancel",
  close: "Close",
  common: {
    system: "System",
    "system-ai": "AI",
    "system-migration": "Migration"
  },
  dismiss: "Dismiss",
  distanceUnit: {
    km: "km"
  },
  dropZone: {
    allowedTypes: "Allowed file types: images and PDFs",
    drop: "Drop files to upload"
  },
  duplicate: {
    receipt: {
      accept: {
        accept: "Yes, I am sure",
        areYouSure: "Are you sure this is not a duplicate?",
        placeholder: "(Optional) give a reason"
      },
      accepted: {
        acceptedBy: "Marked as not a duplicate by {name}",
        hideDetails: "Hide details",
        reviewedBy: "Reviewed by {name}",
        showDetails: "Show details",
        title: "Possible duplicate resolved"
      },
      file: {
        message: "A file identical to #{index} has already been uploaded:"
      },
      ofOwner: "of {ownerName}",
      receipt: "Receipt {name}",
      refresh: "Check again",
      reset: "Reset duplicates",
      review: {
        accept: "Mark as reviewed",
        areYouSure: "Can you confirm this is not a duplicate?",
        placeholder: "(Optional) give a reason"
      },
      similar: {
        message: "A receipt with the same data exists:"
      },
      title: "Possible duplicate found",
      trip: "Trip {name}"
    },
    trip: {
      item: "Receipt {id}",
      message: "These receipts have possibly already been submitted",
      title: "Possible duplicates found"
    }
  },
  email: {
    button: "View {context}",
    comment: {
      action: "{author} added a comment"
    },
    paymentFailures: {
      action: "{count, plural, one {# transaction could not be transferred} other {# transactions could not be transferred}}",
      description: "The latest payment run could not push these transactions to the payment service. They are retried with every run, but each failure is reported only once.",
      subject: "Failed payment transfers",
      transaction: "Transaction"
    },
    reason: {
      base: "You receive this email because you are {reason}",
      owner: "the owner of this item",
      relation: "{relation} of {ofUserName}",
      role: "role {role}"
    },
    transitionBackward: {
      action: "Was set back to {state}",
      description: "Was moved from state {fromState} by {author}"
    },
    transitionForward: {
      action: "Is ready for {state}",
      completed: "Is completed",
      description: "Was moved from state {fromState} by {author}"
    }
  },
  error: "An error occurred:",
  errors: {
    errorCode: {
      maintenance: "The application is currently under maintenance. Please try again later.",
      "unsupported-file-type": "The uploaded file type is not supported. Please upload a different file.",
      "validation-error": "There were validation errors. Please check your input and try again."
    },
    genericServerError: "The server responded with code {statusCode}. Please try again later.",
    statusCode: {
      "400": "Bad Request - The server could not understand the request due to invalid syntax.",
      "401": "Unauthorized - You are not authorized to perform this action. Please log in.",
      "403": "Forbidden - You do not have permission to perform this action.",
      "404": "Not Found - The requested resource was not found.",
      "500": "Server Error - An internal server error occurred. Please try again later."
    }
  },
  expenses: {
    breakfast: "Breakfast",
    businessExpenses: "Daily allowance",
    country: "Country (City)",
    day: "Day",
    daySum: "Daily total",
    dinner: "Dinner",
    endDate: "End Date",
    explainMeal: "Put a checkmark for every meal that you received from the company. They will be deducted from the daily allowance.",
    explainPrivateStay: "Put a checkmark for every overnight stay that is not paid by the company (e.g. staying with family/friends). A fixed rate will be added to the expenses.",
    lunch: "Lunch",
    mealsPaidByEmployer: "Please select the meals paid by the employer.",
    privateStay: "Private Stay",
    startDate: "Start Date",
    sum: "Sum",
    totalSum: "Total Sum"
  },
  expensesEditor: {
    header: "Edit expenses"
  },
  expensesListEntry: {
    excludedMeals: "Meals paid for by the company",
    privateStays: "Private stays",
    title: "Allowance"
  },
  extractedInformation: {
    analyze: "Analyze",
    estimatedCosts: "Est. cost: {estimatedCost} cents",
    field: {
      countryCode: "Country",
      date: "Date",
      item: "Item {index, number}",
      type: "Type"
    },
    title: "AI Extracted Information"
  },
  field: {
    company: "Company",
    countryCode: "Country",
    date: "Date",
    deductions: "Meal deductions",
    description: "Description",
    distance: {
      locationFrom: "From",
      locationTo: "To",
      unit: "Unit",
      value: "Distance",
      vehicleType: "Vehicle"
    },
    duplicates: "Possible duplicates",
    endedOn: "Return",
    files: "Files",
    iban: "IBAN",
    items: "Items",
    locationFrom: "From",
    locationTo: "To",
    mealParticipants: "Participants",
    name: "Name",
    owner: "Owner",
    paid: "Paid",
    rates: "Daily allowance rates",
    startedOn: "Departure",
    sum: "Amount",
    tax: "Incl. Tax",
    total: "Total",
    travelTime: "Travel time",
    type: "Type",
    unit: "Unit",
    value: "Distance",
    vehicleType: "Vehicle"
  },
  fileUploads: {
    loadingOpenCV: "Loading document scanner...",
    saveAsMultiple: "Multiple receipts",
    saveAsOne: "One receipt",
    saveHowText: "You are uploading multiple files. Are they one receipt with multiple pages or multiple receipts?",
    uploadingNew: "Uploading new receipts",
    uploadingToReceipt: "Uploading files to receipt {receiptId}",
    uploadingToTrip: "Uploading receipts to trip {tripId}"
  },
  form: {
    noOptions: "No options",
    previousLocations: "Previous locations"
  },
  general: {
    loading: "Loading..."
  },
  header: {
    listView: "List view",
    newReceipt: "New receipt",
    newTrip: "New trip",
    tableView: "Table view"
  },
  history: {
    actions: {
      acceptDuplicates: "Accepted possible duplicate",
      addFile: "Has added {count, plural, one {a} other {#}} {count, plural, one {file} other {files}}",
      addReceipt: "Has added {count, plural, one {a} other {#}} {count, plural, one {receipt} other {receipts}}",
      addToTrip: "Has added the receipt to trip {tripId}",
      archived: "Archived",
      create_receipt: "Has created the receipt",
      create_trip: "Has created the trip",
      reactivated: "Reactivated",
      removeReceipt: "Has removed {count, plural, one {a} other {#}} {count, plural, one {receipt} other {receipts}}",
      removedFile: "Has removed {count, plural, one {a} other {#}} {count, plural, one {file} other {files}}",
      resetDuplicates: "Reset possible duplicate status",
      reviewDuplicates: "Reviewed possible duplicate",
      transaction: {
        balancedWith: {
          description: "Items with a negative balance are automatically balanced by future positive items. Any remaining positive balance will be transferred.",
          descriptionNegative: "negative balance has been offset by {amount}.",
          descriptionPositive: "positive balance has been offset by {amount}.",
          thisItem: "This item",
          title: "offset against"
        },
        manual: {
          description: "This transaction was made manually by a user clicking the 'Pay' button.",
          title: "manual payment"
        },
        migration: {
          description: "This item has been paid before the payment integration was set up. It was automatically settled by the system.",
          title: "legacy payment"
        },
        payment: {
          status: {
            canceled: "reimbursement canceled",
            completed: "reimbursement completed",
            pending: "reimbursement pending",
            processing: "reimbursement processing"
          }
        },
        paymentService: {
          label: "Payment service",
          values: {
            manual: "Manual",
            odoo: "Odoo",
            qonto: "Qonto"
          }
        },
        reconciliation: {
          types: {
            bucket: "Offset against",
            other: "Offset against another transaction",
            payment: "Bank transfer"
          }
        },
        refund: {
          description: "Too much was paid because the item was canceled or changed after payment. The chargeback will automatically be deducted from future reimbursements.",
          status: {
            canceled: "chargeback canceled",
            completed: "chargeback completed",
            pending: "chargeback pending",
            processing: "chargeback processing"
          }
        }
      },
      transition: "Set to",
      update: "Has updated details",
      updateExpenses: "Has updated expenses"
    },
    agent: "Changed by “{agent}” (AI assistant) on behalf of {name}",
    agentUnknown: "Changed by an AI assistant on behalf of {name}",
    enterComment: "Enter a comment",
    title: "History"
  },
  jobs: {
    attempts: "Attempts",
    duration: "Duration",
    durationSeconds: "{seconds, number} s",
    end: "End",
    error: "Error",
    failedSummary: "{count, plural, one {# job run failed in the last 30 days.} other {# job runs failed in the last 30 days.}}",
    hideFrequent: "Hide frequent jobs (scheduled more often than hourly)",
    job: "Job",
    log: {
      attempt: "Attempt",
      event: "Event",
      message: "Message",
      time: "Time"
    },
    logs: "Logs",
    logsTitle: "Logs of {jobId}",
    noFailures: "No job runs failed in the last 30 days.",
    noLogs: "No log entries.",
    showFailed: "Show failed runs",
    start: "Start",
    state: "State",
    states: {
      completed: "Completed",
      error: "Failed",
      planned: "Planned",
      retrying: "Retrying",
      running: "Running"
    },
    title: "Jobs"
  },
  loggedInInfo: {
    enableAdminRole: "Enable Admin Role",
    impersonate: "Impersonate",
    impersonating: "Impersonating",
    jobs: "Jobs",
    logout: "Logout",
    profile: "Profile",
    reports: "Report View",
    settings: "Settings",
    signedInAs: "Signed in as"
  },
  login: {
    button: "Login",
    error: {
      code: "Error code: {code}",
      description: "Something went wrong while logging in. Please try again, and contact support with the error code below if the problem persists.",
      title: "Login failed",
      userNotRegistered: "Your account is not registered in MEREKO. Please contact support to get access."
    },
    welcome: "Welcome, please log in"
  },
  maintenance: {
    adminBanner: "Maintenance mode is active - regular users are locked out of the application.",
    description: "The application is currently undergoing maintenance. Please try again later.",
    startupDescription: "The application is currently being updated. It will be available again in a few moments.",
    title: "Under maintenance"
  },
  milageAllowance: {
    startTyping: "Type to add location",
    subTitle: "Enter the distances travelled to calculate the mileage allowance",
    title: "Mileage Allowance (private car)"
  },
  navigationWidget: {
    backToOverview: "Back to overview",
    nextItem: "Next item {done}/{total}",
    nextReceipt: "Next receipt",
    prevItem: "Previous",
    previousReceipt: "Previous receipt",
    up: "Back to trip"
  },
  newReceipt: {
    create: "Create receipt",
    pick: "Pick receipt",
    scan: "Scan receipt",
    upload: "Upload receipt"
  },
  noReceiptsYet: {
    empty: "Start by uploading a receipt",
    useDragNDrop: "Or drag and drop a file",
    useScanner: "Use your camera",
    useUpload: "Or select a file"
  },
  oauthConsent: {
    accept: "Allow access",
    deny: "Deny",
    description: "{clientName} wants to access MEREKO on your behalf.",
    error: "The request could not be completed. Please close this page and try connecting again.",
    scopes: {
      email: "See your email address",
      mereko: "Read your trips and receipts and act as you in MEREKO",
      offline_access: "Keep access until you revoke it",
      openid: "Verify your identity",
      profile: "See your basic profile"
    },
    scopesLabel: "The application will be able to:",
    title: "Authorize application",
    unknownClient: "Unknown application"
  },
  ok: "Ok",
  outOfOffice: "Out of office",
  overview: {
    approvalsFor: "Approvals for {name}",
    loadError: "Error when loading your expenses:",
    noMatches: "No matches for your query",
    othersExpenses: "{name}'s expenses",
    total: "Open expenses",
    uploadError: "Error when uploading new receipt:",
    yourExpenses: "Your Expenses"
  },
  participants: {
    company: "Company",
    external: "External",
    name: "Name",
    startTyping: "Type to add participant",
    subTitle: "Enter name and company for all participants",
    title: "Meal participants"
  },
  profilePage: {
    approvers: "Approvers",
    colleagues: "Colleagues",
    displayName: "Display Name",
    email: "Email",
    employeeId: "Employee ID",
    managedEmployees: {
      direct: "Managed Employees",
      directSub: "Managed Employees (substitution)",
      indirect: "Employees Managed By Employees",
      indirectSub: "Employees Managed By Employees (substitution)"
    },
    manager: "Manager",
    personalInfo: "Personal Info",
    profile: "Profile",
    roles: "Roles"
  },
  receipt: "Receipt",
  receiptEditor: {
    addPage: "Add page",
    addSum: "Add item",
    conflict: {
      dismiss: "Dismiss AI value",
      itemWithTax: "{sum} incl. {tax, number, percent} VAT",
      message: "AI found a different value on the receipt: {value}"
    },
    "delete": "Delete page",
    download: "Download page",
    header: "Receipt {receiptId}",
    inclTax: "Incl. {tax, number, percent} VAT",
    noFile: "No file uploaded",
    pdfProcessing: "PDFs can take a few seconds to process",
    rotate: "Rotate page 90° to the right",
    useScanner: "Use your camera",
    useUpload: "Select a file"
  },
  receiptType: {
    airlineticket: "Airline Ticket",
    boardingPass: "Boarding Pass",
    creditCardVoucher: "Credit Card Voucher",
    customAdornment: "Custom Type",
    envelope: "Envelope",
    expenses: "Expenses",
    gasoline: "Gasoline",
    gasolineCompanyCar: "Gasoline (company car)",
    gasolineRentalCar: "Gasoline (rental car)",
    hotel: "Hotel",
    internet: "Internet",
    meal: "Meal",
    milageAllowance: "Mileage Allowance (private car)",
    otherreceipt: "Other Receipt",
    overnight: "Overnight Stay",
    ownReceipt: "Own Receipt",
    parking: "Parking",
    publicTransportation: "Public Transportation",
    rentalcar: "Rental Car",
    taxi: "Taxi",
    trainticket: "Train Ticket"
  },
  relations: {
    additionalApprover: "Additional Approver",
    manager: "Manager",
    substitute: "Substitute"
  },
  report: {
    headers: {
      date: "Date",
      employee: "Employee",
      endedOn: "Return/Receipt date",
      id: "Id",
      locationFrom: "From",
      locationTo: "To",
      manager: "Manager",
      open: "Open",
      paid: "Paid",
      payableTotal: "Payable total",
      startedOn: "Departure",
      state: "State",
      total: "Total",
      type: "Type",
      updatedOn: "Updated on"
    },
    request: {
      download: "Download",
      error: "There was an error while compiling your report:",
      inProgress: "Your report is being compiled...",
      month: "Month",
      noFiles: "No files to download",
      pleaseSelect: "Please select",
      ready: "Your report is ready to download:",
      user: "User"
    },
    title: "Report view",
    types: {
      receipt: "Receipt",
      trip: "Trip"
    }
  },
  retry: "Retry",
  roles: {
    admin: "Admin",
    adminActive: "Admin (Active)",
    backOffice: "Back Office",
    finance: "Finance"
  },
  save: "Save",
  scanner: {
    captureError: "Could not capture image",
    deviceError: "Could not use the video device",
    deviceNeedPermission: "Please allow camera usage",
    devicePermissionDenied: "Device permission denied",
    noDevices: "No camera found"
  },
  search: {
    archived: "Show archived",
    date: "Filter by date",
    directHits: "Direct hits",
    keywords: "Keywords (Ids, Descriptions, Trip destinations)",
    less: "Show less",
    more: "Show {count, number} more",
    ownerId: "Filter by users",
    placeholder: "Start searching and filtering",
    receipt: "Receipt {id}",
    receiptType: "Filter by receipt type",
    recursive: "Show indirect employees",
    selectDate: "Select a date range",
    selectLastMonth: "Last month",
    selectThisMonth: "This month",
    state: "Filter by state",
    trip: "Trip {id}"
  },
  settings: {
    additionalApprovers: "Additional Approvers",
    admin: "Admin Settings",
    autoArchive: "Automatically archive paid items",
    general: "General settings",
    language: "Language",
    languageAuto: "Auto",
    maintenance: {
      enable: "Enable maintenance mode",
      message: "Maintenance message",
      messagePlaceholder: "Shown to locked-out users. Leave empty for a generic message.",
      title: "Maintenance"
    },
    notifications: "Notification settings",
    notifyOwnEmail: "Email for my receipts",
    notifyRoleEmail: "Email for other receipts",
    notifySelf: "Notify for changes I do myself",
    payment: {
      description: "MEREKO needs your payment information to reimburse your expenses.",
      iban: {
        description: "Target IBAN for reimbursements.",
        label: "IBAN"
      },
      paymentRecipient: {
        description: "Name of the payment recipient. Leave empty to use your user name.",
        label: "Payment Recipient"
      },
      title: "Payment Settings"
    },
    paymentSetup: {
      isConfigured: "Payment integration is configured",
      notConfigured: "Payment integration is not configured",
      postBills: "Post bills automatically",
      postBillsDescription: "When disabled, bills are created in {provider} as drafts and must be posted there manually.",
      pullNow: "Update payment status from {provider} now",
      pushNow: "Create payments in {provider} now",
      refreshlogin: "Refresh login",
      setupBy: "Setup by",
      setupOn: "Setup on",
      setupPayment: "Setup payment integration",
      title: "Payment Integration"
    },
    permissions: "Permissions",
    settings: "Settings",
    substitute: "substitute",
    system: {
      sync: "Synchronize AD",
      title: "System"
    },
    testEmail: "Send test email"
  },
  stateWidget: {
    archive: "Archive item.",
    cancel: {
      askConfirmation: "Are you sure you want to cancel this {type}?",
      commentPlaceholder: "(Optional) reason for cancellation",
      description: "Canceled items will remain in the system for the record. If payments have been made, they will result in a negative balance.",
      label: "Cancel this {type}",
      no: "No, keep it",
      yes: "Yes, cancel"
    },
    "delete": {
      askConfirmation: "Are you sure you want to delete this {type}?",
      description: "Deleted items are permanently removed from the system. This action cannot be undone.",
      label: "Delete this {type}",
      no: "No, keep it",
      yes: "Yes, delete"
    },
    moreActions: "More actions",
    payment: {
      missingPaymentDataTitle: "Payment information missing"
    },
    reactivate: "Reactivate item.",
    resetTo: "Reset to \"{state}\" state",
    state: "State",
    waitingFor: "Waiting for"
  },
  stateWidgetChild: {
    relation: "{relation} of {ofUserName}",
    role: "Role {role}"
  },
  states: {
    approval: {
      forward: "Approve",
      name: "Approval"
    },
    canceled: {
      name: "Canceled"
    },
    clearing: {
      forward: "Clear",
      name: "Clearing"
    },
    closing: {
      forward: "Ready for payment",
      name: "Closing"
    },
    completed: {
      name: "Paid"
    },
    draft: {
      forward: "Submit",
      name: "Draft"
    },
    payment: {
      forward: "Pay",
      name: "Payment"
    }
  },
  table: {
    deselectAll: "(Deselect all)"
  },
  tableView: {
    actions: "Actions",
    reports: "Reports",
    settings: "Settings",
    transition: "Modify workflow state",
    transitions: {
      approval: "Approve {count, number} items",
      clearing: "Clear {count, number} items",
      closing: "Close {count, number} items",
      draft: "Submit {count, number} items",
      payment: "Pay {count, number} items"
    }
  },
  thisLanguage: "English",
  trip: "Trip",
  tripEditor: {
    addExistingReceipt: "Add existing receipt",
    addReceipt: "Add receipt",
    addSelectedReceipts: "Add to trip",
    create: "Create trip",
    duplicate: "Create a new trip based on this one",
    empty: "Create a new trip",
    header: "Trip {tripId}",
    processing: "Processing",
    receipts: "Receipts",
    selectReceipts: "Select receipt to add",
    sumOpen: "Open expenses",
    sumPaid: "Reimbursed expenses",
    uploading: "Uploading {current, number}/{total, number}"
  },
  tripEditorNew: {
    chooseTemplate: "Copy info from...",
    header: "Create a trip"
  },
  tripListEntry: {
    emptpy: "No receipts",
    from: "From {from}",
    newTrip: "New trip",
    to: "To {to}",
    tripTo: "Trip to {locationTo}"
  },
  validations: {
    hasDuplicatesUnacceptedByOwner: "Remove or accept duplicate receipts before saving",
    hasDuplicatesUnreviewedByManager: "Review duplicate receipts before saving",
    iban: "Invalid IBAN format",
    invalid: "This value is invalid",
    receipt: {
      date: {
        bounds: "Date must be during the trip"
      },
      extractionConflict: "Differs from the value read from the receipt file - correct it or dismiss the warning"
    },
    required: "\"{field}\" is required",
    thereWereErrors: "There were validation errors",
    tripData: {
      endedOn: {
        bounds: "Return date must be after departure"
      }
    }
  },
  vehicleType: {
    car: "Car",
    motorcycle: "Motorcycle"
  }
} as const;
